var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloneIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49994 9.70005C5.49994 7.72015 5.49994 6.7302 6.11502 6.11508C6.73013 5.5 7.72009 5.5 9.69999 5.5H10.4C12.3799 5.5 13.3699 5.5 13.985 6.11508C14.6001 6.7302 14.6001 7.72015 14.6001 9.70005V10.4001C14.6001 12.38 14.6001 13.3699 13.985 13.985C13.3699 14.6001 12.3799 14.6001 10.4 14.6001H9.69999C7.72009 14.6001 6.73013 14.6001 6.11502 13.985C5.49994 13.3699 5.49994 12.38 5.49994 10.4001V9.70005Z",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 5.49967C11.0984 3.42968 11.0671 2.35748 10.4645 1.62332C10.3482 1.48154 10.2182 1.35154 10.0764 1.23519C9.30192 0.599609 8.15132 0.599609 5.85004 0.599609C3.54878 0.599609 2.39814 0.599609 1.62369 1.23519C1.48191 1.35154 1.35191 1.48154 1.23556 1.62332C0.599976 2.39778 0.599976 3.54841 0.599976 5.84967C0.599976 8.15095 0.599976 9.30156 1.23556 10.076C1.3519 10.2178 1.48191 10.3478 1.62369 10.4641C2.35784 11.0667 3.43005 11.098 5.50004 11.0997",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.05 7.94922V12.1493M12.1501 10.0492H7.95001",
    stroke: "#172B4D",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloneIc);
export default __webpack_public_path__ + "static/media/clone_ic.fce64171096708b6f76587da7f0f4596.svg";
export { ForwardRef as ReactComponent };